import { createAsyncThunk } from '@reduxjs/toolkit';
import { environment } from '../../environments';
import { GetNewProjectBaseSettingsRequest, GetNewProjectBaseSettingsResponse } from '../../models/Project.model';

export const getNewProjectBaseSettings = createAsyncThunk(
  'newProjectSettings/getBaseSettings',
  async (request: GetNewProjectBaseSettingsRequest) => {
    const response = await fetch(`${environment.apiUrl}Project/GetNewProjectBaseSettings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch new project base settings');
    }

    const data: GetNewProjectBaseSettingsResponse = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch new project base settings');
    }

    return data.newProjectBaseSettingDTO;
  }
);